exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!@assets/less/common.less"), "");

// module
exports.push([module.id, "\n.decor-tip[data-v-24694b64] { color: #999; font-size: 12px; margin-left: 12px;\n}\n", ""]);

// exports
